module.exports = __webpack_public_path__ + "img/banner1.2c3c387.png";